import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { ConfigService } from "../../shared/services/config.service";
import { ContactFormComponent } from "../../contact-form/contact-form.component";
import { HomeinformationComponent } from "src/app/homeinformation/homeinformation.component";
import { AboutUsComponent } from '../../about-us/about-us.component';


@Component({
  selector: "app-home-page",
  templateUrl: "./home-page.component.html"
})
export class HomePageComponent implements OnInit {

  homeitems$: Observable<any>;  

  constructor(private config: ConfigService) {}

  scrollToContact(event) {    
    
    const contactElement = document.getElementById("contact");
    const contactPosition = contactElement.offsetTop;
      
    window.scrollTo({
      top: contactPosition,
      behavior: "smooth"
    });
  }

  ngOnInit() {
    this.getPageData("homeitems");
  }

  getPageData(database: string): void {
    this.homeitems$ = this.config.getSettings(database);    
  }
}
